import React from 'react'
import { connect } from 'react-redux'
import LeftToolbar from './left-toolbar'
import PositionedModal from './positioned-modal'
import RightToolbar from './right-toolbar'
import TopMatter from './top-matter'

class MainUI extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { mapReference, is3dMapselected, positionedModal, rightToolbarState } = this.props
    if (!mapReference && !is3dMapselected) {
      return null
    }
    return (
      <div>
        <LeftToolbar />
        {rightToolbarState.hidden ? null : <RightToolbar />}
        <TopMatter />
        {
          positionedModal.data ? <PositionedModal /> : null
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  mapReference: state.mapReference(),
  is3dMapselected: state.is3dMapselected,
  positionedModal: state.positionedModal,
  rightToolbarState: state.rightToolbarState
})

const mapDispatchToProps = dispatch => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(MainUI)